import React from 'react';
import MroLabLanePage from './MroLabLanePage';

export default function MroLabPlanningPage() {
  return <MroLabLanePage laneKey="planning" />;
}
